import { pushGapToArray } from '../../../utilities/pushGapToArray.js';
import { STACKED_BAR_GAP } from '@shopify/polaris-viz-core';

// differently, we need two different methods until we can refactor

function useStackedGapsForVerticalChart({
  stackedValues,
  labels
}) {
  if (stackedValues == null) {
    return [];
  }

  const formattedStackedValues = labels.map((_, labelIndex) => {
    return stackedValues.map(data => {
      return data[labelIndex];
    });
  });
  const groupedGaps = {};
  formattedStackedValues.map((group, groupIndex) => {
    const gaps = {
      positive: [],
      negative: []
    };
    const areAllNegative = !group.some(([start, end]) => {
      return start + end > 0;
    });
    group.forEach(([start, end], index) => {
      if (end > 0) {
        pushGapToArray({
          gaps,
          index,
          direction: 'positive',
          firstGapValue: 0
        });
      }

      if (start < 0) {
        pushGapToArray({
          gaps,
          index,
          direction: 'negative',
          firstGapValue: areAllNegative ? 0 : STACKED_BAR_GAP
        });
      }
    });
    groupedGaps[groupIndex] = gaps;
  });
  return groupedGaps;
}

export { useStackedGapsForVerticalChart };
